import {Injectable} from '@angular/core';
import {LogTypeEnum} from './log-type.enum';
import {OnAppInitInterface} from '@astek/utils';

@Injectable()
export class LoggerService implements OnAppInitInterface {

  private readonly _console: Console = {...console};

  constructor(
  ) {
  }

  public onAppInit(): void {
    console.log = this.log.bind(this);
    console.trace = this.trace.bind(this);
    console.debug = this.debug.bind(this);
    console.info = this.info.bind(this);
    console.warn = this.warn.bind(this);
    console.error = this.error.bind(this);
  }

  public dispose(): void {
    console.log = this._console.log.bind(console);
    console.trace = this._console.trace.bind(console);
    console.debug = this._console.debug.bind(console);
    console.info = this._console.info.bind(console);
    console.warn = this._console.warn.bind(console);
    console.error = this._console.error.bind(console);
  }

  public log(...args: Array<any>): void {
    this.doLog(LogTypeEnum.LOG, args);
  }

  public trace(...args: Array<any>): void {
    this.doLog(LogTypeEnum.TRACE, args);
  }

  public debug(...args: Array<any>): void {
    this.doLog(LogTypeEnum.DEBUG, args);
  }

  public info(...args: Array<any>): void {
    this.doLog(LogTypeEnum.INFO, args);
  }

  public warn(...args: Array<any>): void {
    this.doLog(LogTypeEnum.WARN, args);
  }

  public error(...args: Array<any>): void {
    this.doLog(LogTypeEnum.ERROR, args);
  }

  private doLog(logType: LogTypeEnum, args: Array<any>): void {
    const currentDate = new Date();

    let logFunction: (...args: Array<any>) => void;
    switch (logType) {
      case LogTypeEnum.LOG:
        logFunction = this._console.log.bind(this._console);
        break;
      case LogTypeEnum.TRACE:
        logFunction = this._console.trace.bind(this._console);
        break;
      case LogTypeEnum.DEBUG:
        logFunction = this._console.debug.bind(this._console);
        break;
      case LogTypeEnum.INFO:
        logFunction = this._console.info.bind(this._console);
        break;
      case LogTypeEnum.WARN:
        logFunction = this._console.warn.bind(this._console);
        break;
      case LogTypeEnum.ERROR:
        logFunction = this._console.error.bind(this._console);
        break;
      default:
        throw new Error('Unhandled log type');
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    logFunction(this.logPrefix(logType, currentDate), ...args);
  }

  private logPrefix(type: LogTypeEnum, date: Date | null = null): string {
    let logLevel = '';
    switch (type) {
      case LogTypeEnum.DEBUG:
        logLevel = 'DEBUG  ';
        break;
      case LogTypeEnum.INFO:
        logLevel = 'INFO   ';
        break;
      case LogTypeEnum.WARN:
        logLevel = 'WARNING';
        break;
      case LogTypeEnum.ERROR:
        logLevel = 'ERROR  ';
        break;
      default:
        logLevel = 'VERBOSE';
        break;
    }
    return `${logLevel} | ${this.nowString(date)} |`;
  }

  private nowString(date: Date | null = null): string {
    const currentDate = date ?? new Date();
    return `${this.integerString(currentDate.getFullYear(), 4)}`
      + `.${this.integerString(currentDate.getMonth() + 1, 2)}`
      + `.${this.integerString(currentDate.getDate(), 2)}`
      + `-${this.integerString(currentDate.getHours(), 2)}`
      + `:${this.integerString(currentDate.getMinutes(), 2)}`
      + `:${this.integerString(currentDate.getSeconds(), 2)}`
      + `.${this.integerString(currentDate.getMilliseconds(), 3)}`;
  }

  private integerString(value: number, digits: number): string {
    return value.toFixed(0).padStart(digits, '0');
  }

}
